/* Charliee footer - menu columns become accordions on mobile only.
 * Toggling the `open` attribute is more reliable across browsers than trying
 * to override the UA styling of a closed <details> with CSS.
 */
(function () {
  var mq = window.matchMedia('(max-width: 749px)');

  function sync() {
    var cols = document.querySelectorAll('.cfoot__col');
    for (var i = 0; i < cols.length; i++) {
      if (mq.matches) {
        cols[i].removeAttribute('open');
      } else {
        cols[i].setAttribute('open', '');
      }
    }
  }

  sync();
  if (mq.addEventListener) {
    mq.addEventListener('change', sync);
  } else if (mq.addListener) {
    mq.addListener(sync);
  }
  document.addEventListener('shopify:section:load', sync);
})();
